export default __webpack_public_path__ + "static/media/versionHistory.a732729e.svg";